import { CONSUMPTION } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';


// ACTIONS
const rawActions = actionsFactory(CONSUMPTION);
const actions = { ...rawActions, ...thunkFactory(CONSUMPTION, '/consumptions/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(CONSUMPTION, initialState);

// SAGAS
const sagas = sagasFactory(CONSUMPTION, '/consumptions/', { scopedByAccount: true });
export { sagas };
